import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomTrackingWalletsTable } from '../../atoms/reatom-tracking-wallets-table'

type TrackingWalletsTableProps = {}

export const TrackingWalletsTable: React.FC<TrackingWalletsTableProps> = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomTrackingWalletsTable(), [])

  return <AppDataTable model={model} />
}
